import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'photoswipe/style.css'

class ProductGallery extends HTMLElement {
  constructor() {
    super()
    this.slides = []
    this._lightbox = null
    this.openLightbox = this.openLightbox.bind(this)
  }

  // Getter for lightbox
  get lightbox() {
    if (!this._lightbox) {
      this._lightbox = new PhotoSwipeLightbox({
        pswpModule: () => import('photoswipe'),
        bgOpacity: 0.9,
        maxZoomLevel: 3,
        closeTitle: 'Close (Esc)',
        zoomTitle: 'Zoom in/out',
        errorMsg: 'Error',
        arrowPrev: false,
        arrowNext: false,
        counter: false,
        close: false,
        zoom: false,
        allowPanToNext: true,
      })
      this._lightbox.init()
      this._lightbox.on('uiRegister', this.lightBoxRegister.bind(this))
    }
    return this._lightbox
  }

  lightBoxRegister() {
    /* Close Button */

    this.lightbox.pswp.ui.registerElement({
      name: 'close-button',
      className: 'btn',
      ariaLabel: window.jsStrings.close || `Close`,
      order: 2,
      isButton: true,
      html: `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" aria-hidden="true" focusable="false" role="presentation">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      `,
      onClick: () => {
        this.lightbox.pswp.close()
      },
    })
    const numberOfSlides = this.lightbox.pswp.options.dataSource.length

    if (numberOfSlides > 1) {
      this.lightbox.pswp.ui.registerElement({
        name: 'previous-button',
        className: 'btn',
        ariaLabel: window.jsStrings.prevSlide || `Previous`,
        order: 1,
        isButton: true,
        html: `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" aria-hidden="true" focusable="false" role="presentation">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
        </svg>
        `,
        onClick: () => {
          this.lightbox.pswp.prev()
        },
      })
      this.lightbox.pswp.ui.registerElement({
        name: 'next-button',
        className: 'btn',
        ariaLabel: window.jsStrings.nextSlide || `Next`,
        order: 3,
        isButton: true,
        html: `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" aria-hidden="true" focusable="false" role="presentation">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
        </svg>
        `,
        onClick: () => {
          this.lightbox.pswp.next()
        },
      })
    }
  }

  openLightbox(e) {
    const targetIndex = e.target
      .closest('[data-image-index]')
      .getAttribute('data-image-index')

    // Access lightbox via getter
    const lightbox = this.lightbox
    const images = this.slides.map((slide) => {
      return slide.querySelector('img')
    })

    const dataSource = images.map((image) => {
      return {
        thumbnailElement: image,
        src: image.src,
        srcset: image.srcset,
        msrc: image.currentSrc || image.src,
        width: parseInt(image.getAttribute('width')),
        height: parseInt(image.getAttribute('height')),
        alt: image.alt,
        thumbCropped: true,
      }
    })

    const index = parseInt(targetIndex) || 0

    lightbox.loadAndOpen(index, dataSource)
  }

  connectedCallback() {
    if (window.innerWidth < 1024) {
      // If it is, do not initialize the component's functionality
      return
    }

    this.slides = Array.from(this.querySelectorAll('[data-image-index]'))
    this.slides.forEach((slide) => {
      slide.addEventListener('click', this.openLightbox)
    })
  }
}

window.customElements.define('core-product-gallery', ProductGallery)
